import { useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/system";
import { type GQLRecentlyViewedModelFragment } from "@src/graphql.generated";

export const useResolveModelsPerPage = () => {
    const theme = useTheme();
    const isMediumScreen = useMediaQuery(theme.breakpoints.up("md"));
    const isLargeScreen = useMediaQuery(theme.breakpoints.up("lg"));
    let numberOfModelsPerPage = 2;
    if (isMediumScreen) numberOfModelsPerPage = 3;
    if (isLargeScreen) numberOfModelsPerPage = 5;

    return numberOfModelsPerPage;
};

export const sortModelsByViewed = (viewedModels: string[], models?: GQLRecentlyViewedModelFragment[]) => {
    return models?.slice().sort((a, b) => {
        const aIndex = viewedModels.indexOf(a.id);
        const bIndex = viewedModels.indexOf(b.id);

        return aIndex - bIndex;
    });
};

export const splitModelsIntoChunksPerPage = (models: GQLRecentlyViewedModelFragment[], chunksPerPage: number): GQLRecentlyViewedModelFragment[][] => {
    return models.reduce<GQLRecentlyViewedModelFragment[][]>((resultArray, item, index) => {
        const chunkIndex = Math.floor(index / chunksPerPage);
        if (!resultArray[chunkIndex]) {
            resultArray[chunkIndex] = []; // start a new chunk
        }
        resultArray[chunkIndex].push(item);

        return resultArray;
    }, []);
};
